var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBroadcastPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#broadcast-pencil_svg__clip0_183_11304)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.794 13.5H3a.5.5 0 01-.5-.5v-2.794a.494.494 0 01.144-.35l7.5-7.5a.5.5 0 01.712 0l2.788 2.788a.5.5 0 010 .712l-7.5 7.5a.492.492 0 01-.35.144v0zM8.5 4L12 7.5M10.25 5.75l-6 6M5.969 13.469L2.53 10.03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "broadcast-pencil_svg__clip0_183_11304"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

export default SvgBroadcastPencil;